import { render, staticRenderFns } from "./BlogComments.vue?vue&type=template&id=3c98fc65&scoped=true&"
import script from "./BlogComments.vue?vue&type=script&lang=js&"
export * from "./BlogComments.vue?vue&type=script&lang=js&"
import style0 from "./BlogComments.vue?vue&type=style&index=0&id=3c98fc65&lang=scss&scoped=true&"
import style1 from "./BlogComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98fc65",
  null
  
)

export default component.exports